var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { requiredParam } from 'sdc-utilities';

import { async } from '../AsyncHelper';
import { defer } from '../Deferred';
import { isTransient } from '../../http/helper';

var Reading = function Reading(superclass) {
  return function (_superclass) {
    _inherits(_class2, _superclass);

    function _class2() {
      var _temp, _this, _ret;

      _classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _superclass.call.apply(_superclass, [this].concat(args))), _this), _this.handleAnyError = function (_ref) {
        var process = _ref.process,
            tag = _ref.tag,
            retryCount = _ref.retryCount,
            options = _objectWithoutProperties(_ref, ['process', 'tag', 'retryCount']);

        return function (error) {
          console.warn(tag, error.message);
          console.warn('isTransient()', isTransient(error));
          if (isTransient(error) && ++retryCount < 10) {
            setTimeout(process(_extends({}, options, { retryCount: retryCount })), 500);
          } else if (options.onError) {
            options.onError(error);
          }
        };
      }, _this.load = function (_ref2) {
        var _ref2$apiCall = _ref2.apiCall,
            apiCall = _ref2$apiCall === undefined ? requiredParam('apiCall') : _ref2$apiCall,
            _ref2$callback = _ref2.callback,
            callback = _ref2$callback === undefined ? requiredParam('callback') : _ref2$callback,
            _ref2$retryCount = _ref2.retryCount,
            retryCount = _ref2$retryCount === undefined ? 0 : _ref2$retryCount,
            onError = _ref2.onError;
        return function () {
          return defer(function (deferred) {
            var handleError = _this.handleAnyError({
              apiCall: apiCall,
              callback: callback,
              retryCount: retryCount,
              onError: onError,
              tag: 'load()',
              process: _this.load
            });
            try {
              async(apiCall).then(callback(deferred)).catch(handleError);
            } catch (error) {
              handleError(error);
            }
          });
        };
      }, _this.list = function (_ref3) {
        var params = _ref3.params,
            _ref3$callback = _ref3.callback,
            callback = _ref3$callback === undefined ? _this.setEntries : _ref3$callback,
            _ref3$retryCount = _ref3.retryCount,
            retryCount = _ref3$retryCount === undefined ? 0 : _ref3$retryCount,
            onError = _ref3.onError;
        return function () {
          return defer(function (deferred) {
            var handleError = _this.handleAnyError({
              params: params,
              callback: callback,
              retryCount: retryCount,
              onError: onError,
              tag: 'list()',
              process: _this.list
            });
            try {
              async(_this.api.list(params)).then(callback(deferred)).catch(handleError);
            } catch (error) {
              console.warn(error);
              handleError(error);
            }
          });
        };
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return _class2;
  }(superclass);
};
export { Reading };